import styles from "./styles.module.scss";

export const VARIANT_STYLES = {
  filled: styles.filled,
  outlined: styles.outlined,
  text: styles.text,
};
